import React, { Component } from 'react';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import {StickyTable, Row, Cell} from 'react-sticky-table';
import Tooltip from '@material-ui/core/Tooltip';

import Button from '@material-ui/core/Button';

import { api_host, api_auth } from '../../../../../common/globals/constants';
import icons from '../../../../../theme/icons.js';
class ObjectiveCell extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            objective: this.props.objectivesList,
            nodesIdList: this.props.nodesIdList,
            isLoading: true
        }
    }
    componentDidMount() {
        this.getDataFromAPI();
    } 
    getDataFromAPI = (objectiveId) => {
        
        const {objective, nodesIdList} = this.state
        let token = sessionStorage.getItem('key')
        let user = sessionStorage.getItem('user')
        var monitors = objective.Monitores
        var steps = objective.Pasos
        var interval = objective.intervalo_id
        Promise.all([
            fetch(api_host+`/reporte/online/indicadores/getLastStatusObjectiveByNode/?user=${user}&objetivoId=${objective.objetivo_id}&token=${token}&key=07374CEAC2EAEF2EB3441BA0C433F9834E6CF6E2`)
        ])
        .then(([res1]) => {
            return Promise.all([res1.json()])
        })
        .then(([res1]) => {
            //.then(response => response.json())
            //.then(myJson => { 
                let cell = []
                Object(nodesIdList).map((node, orden)=>{
                    var ok = false
                    var cellData = {}
                    Object(res1.nodos).map((nodeStatus, orden)=>{
                        if (node == nodeStatus.nodo_id && !ok){
                            if (nodeStatus.paso != ''){
                                cellData['step'] = nodeStatus.paso.nombre_paso
                            } else {
                                cellData['step'] = ''
                            }
                            cellData['status'] = nodeStatus.status
                            cellData['code'] = nodeStatus.codigo
                            if (nodeStatus.duracion >= 86400){
                                var newDate = new Date(parseInt(nodeStatus.duracion) * 1000)
                                var day = parseInt(newDate.getDate())
                                cellData['duration'] = day + ' día(s) ' + new Date(parseInt(nodeStatus.duracion) * 1000).toISOString().substr(11, 8)
                            }else{
                                cellData['duration'] = new Date(parseInt(nodeStatus.duracion) * 1000).toISOString().substr(11, 8)
                            }
                            var date = nodeStatus.fecha_tz.replace('T',' ').substr(0, 19)
                            var dateYear = date.substr(0, 10)
                            var dateYYYY = dateYear.substr(0, 4)
                            var datemm = dateYear.substr(5, 2)
                            var datedd = dateYear.substr(8, 9)
                            cellData['date'] = date.substr(11, 19)+' '+datedd+'-'+datemm+'-'+dateYYYY
                            var colorEvent = '#41B900'    
                            var icon = <i style={{...icons.sprite, ...icons.spriteOK}}/> 
                            var nameEvent = 'Ok'                 
                            if(nodeStatus.status === "no_monitoreo"){
                                icon = <i style={{...icons.sprite, ...icons.spriteNO_MONITOREO}}/>
                                colorEvent = ' #A9A9A9'
                                nameEvent = 'Periodo sin monitoreo' 
                            }else if(nodeStatus.status === "downtime"){
                                colorEvent = '#C2272D'
                                if (parseInt(nodeStatus.codigo) == 27){
                                    icon = <i style={{...icons.sprite, ...icons.spriteTIMEOUT_JS}}/>
                                    nameEvent = 'Timeout javascript' 
                                } else if (parseInt(nodeStatus.codigo) == 13){
                                    icon = <i style={{...icons.sprite, ...icons.spriteERROR_CONTENIDO}}/>
                                    nameEvent = 'Error de contenido' 
                                } else if (parseInt(nodeStatus.codigo) == 1006){
                                    icon = <i style={{...icons.sprite, ...icons.spriteTIMEOUT_DE_LA_OPERACION_DEL_SOCKET}}/>
                                    nameEvent = 'Timeout de la operación del socket' 
                                } else if (parseInt(nodeStatus.codigo) == 3){
                                    icon = <i style={{...icons.sprite, ...icons.sprite_TIMEOUT}}/>
                                    nameEvent = 'Timeout' 
                                } else if (parseInt(nodeStatus.codigo) == 500){
                                    icon = <i style={{...icons.sprite, ...icons.sprite500}}/>
                                    nameEvent = 'Error 500' 
                                } else if (parseInt(nodeStatus.codigo) == 613){
                                    icon = <i style={{...icons.sprite, ...icons.spriteERROR_CONTENIDO}}/>
                                    nameEvent = 'Error de contenido' 
                                } else if (parseInt(nodeStatus.codigo) == 603){
                                    icon = <i style={{...icons.sprite, ...icons.spriteLLAMADA_COLGADA}}/>
                                    nameEvent = 'Troncal ocupado' 
                                } else if (parseInt(nodeStatus.codigo) == 610){
                                    icon = <i style={{...icons.sprite, ...icons.spriteTRONCAL_OCUPADO}}/>
                                    nameEvent = 'Llamada colgada' 
                                } else if (parseInt(nodeStatus.codigo) == 999999){
                                    icon = <i style={{...icons.sprite, ...icons.spriteERROR_DESCONOCIDO_EN_SCRIPT}}/>
                                    nameEvent = 'Error desconocido en script' 
                                } else if (parseInt(nodeStatus.codigo) == 607){
                                    icon = <i style={{...icons.sprite, ...icons.sprite_TIMEOUT}}/>
                                    nameEvent = 'Timeout' 
                                } else if (parseInt(nodeStatus.codigo) == 601){
                                    icon = <i style={{...icons.sprite, ...icons.spriteTRONCAL_CONGESTIONADO}}/>
                                    nameEvent = 'Troncal congestionado' 
                                } else if (parseInt(nodeStatus.codigo) == 404){
                                    icon = <i style={{...icons.sprite, ...icons.sprite404}}/>
                                    nameEvent = 'Error 404' 
                                }else if (parseInt(nodeStatus.codigo) == 1004){
                                    icon = <i style={{...icons.sprite, ...icons.spriteTIMEOUT_EN_CONEXION}}/>
                                    nameEvent = 'Timeout en Conexión' 
                                }else if (parseInt(nodeStatus.codigo) == 503){
                                    icon = <i style={{...icons.sprite, ...icons.sprite503}}/>
                                    nameEvent = 'Error 503' 
                                }else{
                                    icon = <i style={{...icons.sprite, ...icons.spriteSIN_NOMBRE}}/>
                                    nameEvent = 'Error' 
                                }
                            } 
                            cellData['nameEvent'] = nameEvent
                            cellData['icon'] = icon
                            cellData['color'] = colorEvent
                            cell.push(cellData)
                            ok = true
                        } 
                    })
                    if (!ok){
                        cellData['status'] = ""
                        cellData['code'] = ""
                        cellData['duration'] = ""
                        cellData['color'] = ""
                        cellData['icon'] = ""
                        cellData['step'] = ""
                        cell.push(cellData)
                    }
                })
                this.setState({cells: cell, isLoading: false});
            })
        
    }
    processData = (externalData) => {
    }

    handleClose = event => {

        /*if (reason === 'clickaway') {
          	return;
        }
        this.setState({
            open: false 
        })*/
        this.props.onClose()
    };
    
    render() {
        const {isLoading, cells, objective} = this.state
        
        if (!isLoading)  {
            return  <Row>
                        <Tooltip title={<div><Typography variant="h4" style={{color:'white'}}>{objective.nombre}</Typography></div>} placement="right" arrow>
                            <Cell style={{maxWidth:'280px', minWidth:'280px', backgroundColor: objective.color_custom, color:'white', borderBottom: "2px solid #e4dede"}}>
                                <Button id={objective.objetivo_id} value={objective.nombre} onClick={this.props.handleOpenObjectiveModal}>
                                    <Typography variant="h5" style={{color:'white'}}>{objective.nombre.substr(0,25)}</Typography>
                                </Button>
                            </Cell>
                        </Tooltip>
                        {Object(cells).map(cell=>(
                            cell.icon != "" ? <Tooltip 
                                title={<div>
                                    <Typography variant="h4" style={{color:'white'}}>{cell.nameEvent}</Typography>
                                    <Typography variant="h6" style={{color:'white'}}>{"Fecha: "+cell.date}</Typography>
                                    <Typography variant="h6" style={{color:'white'}}>{"Duración: "+cell.duration}</Typography>
                                    {cell.step != '' ?<Typography variant="h6" style={{color:'white'}}>{"Paso error: "+cell.step}</Typography>:null}
                                    </div>} 
                                placement="bottom" arrow>
                                <Cell style={{maxWidth:'130px', minWidth:'130px', borderBottom: "2px solid #d4d4d4", borderRight: "2px solid #e4dede", backgroundColor: '#e9e9e9'}}><Typography style={{height:"50px", paddingLeft:'30px'}}>{cell.icon}</Typography></Cell>
                            </Tooltip>
                            : <Cell style={{maxWidth:'130px', minWidth:'130px', borderBottom: "2px solid #d4d4d4", borderRight: "2px solid #e4dede", backgroundColor: '#e9e9e9'}}><Typography style={{height:"50px", paddingLeft:'30px'}}>{cell.icon}</Typography></Cell>
                        ))}
                    </Row>          
            
        } else {
            return <div>      
                    <Typography
                        
                        variant="h5">
                        <CircularProgress
                            variant="indeterminate"      
                            size={24}
                            thickness={4}                            
                        />
                        Cargando Información...
                    </Typography>        
                </div>     
        }
    }
}
export default ObjectiveCell;